<template>
  <div class="login">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>商城后台管理系统</span>
      </div>
      <el-form label-width="50px">
        <el-form-item>
          <el-input type="text" v-model="username" class="pw" placeholder="账号：">
            <i slot="prefix" class="el-input__icon el-icon-s-custom"></i>
          </el-input>
          <el-input type="password" v-model="password" class="pw" placeholder="密码：">
            <i slot="prefix" class="el-input__icon el-icon-lock"></i>
          </el-input>
          <el-button type="primary" @click="handlelogin">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 账号
      username: '',
      // 密码
      password: ''
    }
  },
  methods: {
    // 点击登录
    handlelogin() {
      // 航越
      if(
        (this.username == 'cw' && this.password == 'cw') ||
        (this.username == 'jf' && this.password == 'jf') ||
        (this.username == 'nsy' && this.password == 'nsy') ||
        (this.username == 'wd' && this.password == 'wd') ||
        (this.username == 'hjx' && this.password == 'hjx') ||
        (this.username == 'wxx' && this.password == 'wxx') ||
        (this.username == 'zr' && this.password == 'zr') ||
        (this.username == 'zsf' && this.password == 'zsf')
      ){
        window.localStorage.setItem('un',this.username);
        this.$router.push({ path: "/home/orderlist" });
        this.$message({
          message: '登录成功!!!',
          type: 'success'
        });
        return false;
      }
      // 仓库
      else if(
        (this.username == 'ck' && this.password == 'ck')
      ){
        window.localStorage.setItem('un',this.username);
        this.$router.push({ path: "/home/productlist_A" });
        this.$message({
          message: '登录成功!!!',
          type: 'success'
        });
        return false;
      }
      // 物流
      else if((this.username == 'ckwj' && this.password == 'ckwj')){
        window.localStorage.setItem('un',this.username);
        this.$router.push({ path: "/home/productlist_B" });
        this.$message({
          message: '登录成功!!!',
          type: 'success'
        });
        return false;
      }
      else if(this.username == '' || this.password == ''){
        this.$message({
          message: '账号或密码不能为空',
          type: 'warning'
        });
        return false;
      }
      else if(
        (this.username != 'cw' &&
         this.username != 'jf' &&
         this.username != 'nsy' &&
         this.username != 'wd' &&
         this.username != 'hjx' &&
         this.username != 'wxx' &&
         this.username != 'zr' &&
         this.username != 'zsf' &&
         this.username != 'ck' &&
         this.username != 'ckwj')
        || 
        (this.password != 'cw' &&
         this.password != 'jf' &&
         this.password != 'nsy' &&
         this.password != 'wd' &&
         this.password != 'hjx' &&
         this.password != 'wxx' &&
         this.password != 'zr' &&
         this.password != 'zsf' &&
         this.password != 'ck' &&
         this.password != 'ckwj')
      ){
        this.$message({
          message: '账号或密码输入错误',
          type: 'error'
        });
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  position: absolute;
  background: url('../assets/bg.jpg');
  background-size: 100% 100%;
  background-attachment: fixed;
  .box-card {
    width: 450px;
    margin: 200px auto;
    background: rgba(255,255,2525,0.6);
    .clearfix {
      padding-left: 30px;
      text-align: center;
    }
    .el-form,
    .clearfix {
      margin-right: 50px;
    }
    .pw {
      margin-bottom: 20px;
    }
    span {
      font-size: 30px;
      font-weight: bolder;
    }
    .el-button {
      width: 100%;
    }
  }
}
</style>